"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _omniex = _interopRequireDefault(require("./omniex"));

var _six = _interopRequireDefault(require("./six"));

var palette = {
  omniex: _omniex.default,
  six: _six.default
}[process.env.REACT_APP_INSTALLATION] || _omniex.default;
var black = '#1B1C1D';
var blue = '#006FBF';
var green = '#21BA45';
var grey = '#6F6F6F';
var orange = '#EF7D4A';
var red = '#DB2828';
var white = '#FFFFFF';
var lightBlack = '#545454';
var borderColor = 'rgba(34, 36, 38, 0.15)';
var internalBorderColor = 'rgba(34, 36, 38, 0.1)';
var solidBorderColor = '#D4D4D5';
var transparentBlack = 'rgba(0, 0, 0, 0.05)';
var transparentBlack10 = 'rgba(0, 0, 0, 0.1)';
var actionButtonTextColor = white;
var actionButtonBackgroundColor = blue;
var cancelButtonTextColor = white;
var cancelButtonBackgroundColor = orange;
var dropdownBorderColor = '#96C8DA';
var hoverBorderColor = 'rgba(34,36,38,0.35)';
var multiLabelColor = 'rgba(0,0,0,0.6)';
var placeholderColor = 'rgba(191,191,191,0.87)';
var selectedColor = 'rgba(0, 0, 0, 0.03)';
var inactiveTabColor = '#F2F2F2';
var infoBackgroundColor = '#F2F9FF';
var infoBorderColor = blue;
var infoColor = blue;
var infoHeaderColor = blue;
var infoTextColor = blue;
var negativeBackgroundColor = '#FFF6F6';
var negativeBorderColor = '#E0B4B4';
var negativeColor = red;
var negativeHeaderColor = '#912D2B';
var negativeTextColor = '#9F3A38';
var positiveBackgroundColor = '#FCFFF5';
var positiveBorderColor = '#A3C293';
var positiveColor = green;
var positiveHeaderColor = '#1A531B';
var positiveTextColor = '#2C662D';
var warningBackgroundColor = '#FFFAF3';
var warningBorderColor = '#C9BA9B';
var warningColor = '#F2C037';
var warningHeaderColor = '#794B02';
var warningTextColor = '#573A08';
var errorBackgroundColor = negativeBackgroundColor;
var errorBorderColor = negativeBorderColor;
var errorColor = negativeColor;
var errorHeaderColor = negativeHeaderColor;
var errorTextColor = negativeTextColor;
var successBackgroundColor = positiveBackgroundColor;
var successBorderColor = positiveBorderColor;
var successColor = positiveColor;
var successHeaderColor = positiveHeaderColor;
var successTextColor = positiveTextColor;
var selectedBackgroundColor = transparentBlack10;
var selectedTextColor = orange;

var _default = (0, _objectSpread2.default)({
  actionButtonTextColor: actionButtonTextColor,
  actionButtonBackgroundColor: actionButtonBackgroundColor,
  black: black,
  blue: blue,
  borderColor: borderColor,
  cancelButtonTextColor: cancelButtonTextColor,
  cancelButtonBackgroundColor: cancelButtonBackgroundColor,
  dropdownBorderColor: dropdownBorderColor,
  errorBackgroundColor: errorBackgroundColor,
  errorBorderColor: errorBorderColor,
  errorColor: errorColor,
  errorHeaderColor: errorHeaderColor,
  errorTextColor: errorTextColor,
  green: green,
  grey: grey,
  hoverBorderColor: hoverBorderColor,
  inactiveTabColor: inactiveTabColor,
  infoBackgroundColor: infoBackgroundColor,
  infoBorderColor: infoBorderColor,
  infoColor: infoColor,
  infoHeaderColor: infoHeaderColor,
  infoTextColor: infoTextColor,
  internalBorderColor: internalBorderColor,
  lightBlack: lightBlack,
  multiLabelColor: multiLabelColor,
  negativeBackgroundColor: negativeBackgroundColor,
  negativeBorderColor: negativeBorderColor,
  negativeColor: negativeColor,
  negativeHeaderColor: negativeHeaderColor,
  negativeTextColor: negativeTextColor,
  orange: orange,
  placeholderColor: placeholderColor,
  positiveBackgroundColor: positiveBackgroundColor,
  positiveBorderColor: positiveBorderColor,
  positiveColor: positiveColor,
  positiveHeaderColor: positiveHeaderColor,
  positiveTextColor: positiveTextColor,
  red: red,
  selectedBackgroundColor: selectedBackgroundColor,
  selectedColor: selectedColor,
  selectedTextColor: selectedTextColor,
  solidBorderColor: solidBorderColor,
  successBackgroundColor: successBackgroundColor,
  successBorderColor: successBorderColor,
  successColor: successColor,
  successHeaderColor: successHeaderColor,
  successTextColor: successTextColor,
  transparentBlack: transparentBlack,
  transparentBlack10: transparentBlack10,
  warningBackgroundColor: warningBackgroundColor,
  warningBorderColor: warningBorderColor,
  warningColor: warningColor,
  warningHeaderColor: warningHeaderColor,
  warningTextColor: warningTextColor,
  white: white
}, palette);

exports.default = _default;